const mixin = {
  methods: {
    downloadExcel(filename) {
      let csv = [];
      let rows = document.querySelectorAll("table tr");

      for (let i = 0; i < rows.length; i++) {
        let row = [], cols = rows[i].querySelectorAll("td, th");

        for (let j = 0; j < cols.length; j++) row.push(cols[j].innerText);

        csv.push(row.join(","));
      }


      // Download CSV file
      this.downloadCSV(csv.join("\n"), filename);
    },

    downloadCSV(csv, filename) {
      let csvFile;
      let downloadLink;

      // CSV file
      csvFile = new Blob([csv], {type: "text/csv"});
      // Download link
      downloadLink = document.createElement("a");
      // File name
      downloadLink.download = filename;
      // Create a link to the file
      downloadLink.href = window.URL.createObjectURL(csvFile);
      // Hide download link
      downloadLink.style.display = "none";
      // Add the link to DOM
      document.body.appendChild(downloadLink);
      // Click download link
      downloadLink.click();
    }, print() {
      let table = document.querySelector('.VueTables__table');
      let tableClone = table.cloneNode(true);
      let tableInputs = tableClone.querySelectorAll('input, select');
      for (let i = 0; i < tableInputs.length; i++) {
        tableInputs[i].remove()
      }
      if (this.columns.includes('actions')) {
        let allRows = tableClone.rows;
        for (let i = 0; i < allRows.length; i++) {
          allRows[i].deleteCell(-1)
        }
      }

      tableClone.setAttribute('border', 1);
      let newWin = window.open('')
      newWin.document.write(tableClone.outerHTML)
      newWin.document.dir = 'rtl'

      newWin.print()
      newWin.close()
    },
  }
}

export default mixin;
